/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ReadOnlyComments.vue?vue&type=template&id=418f0270&scoped=true"
import script from "./ReadOnlyComments.ts?vue&type=script&lang=ts&external"
export * from "./ReadOnlyComments.ts?vue&type=script&lang=ts&external"
import style0 from "./ReadOnlyComments.vue?vue&type=style&index=0&id=418f0270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f0270",
  null
  
)

export default component.exports